// @flow

import clients from './clients';
import myCompany from './myCompany';
import myDashboard from './myDashboard';
import partnerProfile from './partnerProfile';

const tables = {};

tables.clients = clients;
tables.myCompany = myCompany;
tables.myDashboard = myDashboard;
tables.partnerProfile = partnerProfile;

export default tables;
